module.exports = __webpack_public_path__ + "img/landscape_7-lazy.5ba45216.jpg";